// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__3i86Q","tabs":"Settings_tabs__M8PaE","tab":"Settings_tab__yHrYP","active":"Settings_active__RYhnw","tab-content":"Settings_tab-content__2MXSM"};